import moment from "moment";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import {
    TWITTER_INSIGHTS_AUTHENTICATE,
    FETCH_TWITTER_PAGE_LIST,
    SET_TWITTER_SELECTED_PAGE,
    UPDATE_TWITTER_DURATION_FILTER,
    FETCH_TWITTER_CHART_DATA,
} from "../actions/twitterInsightsActions";

const twitterInsightsReducer = (
    state = {
        twitterLoginStatus: false,
        authenticationFailed: false,
        pageListLoading: false,
        pageList: [],
        selectedTwPage: undefined,
        durationFilter: {
            duration: "7",
            startDateTime: moment(new Date()).subtract(6, "days").startOf("day").format("YYYY-MM-DD"),
            endDateTime: moment(new Date()).format("YYYY-MM-DD"),
        },
        chartData: {},
        chartDataLoading: {},
        chartDataError: {},
    },
    action,
) => {
    switch (action.type) {
        case isRejected(TWITTER_INSIGHTS_AUTHENTICATE):
            return (state = {
                ...state,
                twitterLoginStatus: false,
                authenticationFailed: true,
            });
        case isFulfilled(TWITTER_INSIGHTS_AUTHENTICATE):
            if (action.payload.status === "success") {
                return (state = {
                    ...state,
                    twitterLoginStatus: true,
                    authenticationFailed: false,
                });
            } else {
                return (state = {
                    ...state,
                    twitterLoginStatus: false,
                    authenticationFailed: true,
                });
            }

        case isPending(FETCH_TWITTER_PAGE_LIST):
            return (state = {
                ...state,
                pageListLoading: true,
            });
        case isRejected(FETCH_TWITTER_PAGE_LIST):
            return (state = {
                ...state,
                pageListLoading: false,
            });
        case isFulfilled(FETCH_TWITTER_PAGE_LIST):
            return (state = {
                ...state,
                pageList: action.payload || [],
                pageListLoading: false,
            });
        case SET_TWITTER_SELECTED_PAGE:
            return (state = {
                ...state,
                selectedTwPage: action.payload,
            });
        case UPDATE_TWITTER_DURATION_FILTER:
            return (state = {
                ...state,
                durationFilter: { ...state.durationFilter, ...action.payload },
            });

        case isFulfilled(FETCH_TWITTER_CHART_DATA): {
            let chartData = state.chartData;
            let chartDataLoading = state.chartDataLoading;
            let chartDataError = state.chartDataError;
            chartData[action.key] = action.payload;
            chartDataLoading[action.key] = false;
            chartDataError[action.key] = false;
            return {
                ...state,
                chartData,
                chartDataLoading,
                chartDataError,
            };
        }
        case isPending(FETCH_TWITTER_CHART_DATA): {
            let chartData = state.chartData;
            let chartDataLoading = state.chartDataLoading;
            let chartDataError = state.chartDataError;
            chartData[action.key] = null;
            chartDataLoading[action.key] = true;
            chartDataError[action.key] = false;
            return {
                ...state,
                chartData,
                chartDataLoading,
                chartDataError,
            };
        }
        case isRejected(FETCH_TWITTER_CHART_DATA): {
            let chartData = state.chartData;
            let chartDataLoading = state.chartDataLoading;
            let chartDataError = state.chartDataError;
            chartData[action.key] = null;
            chartDataLoading[action.key] = false;
            chartDataError[action.key] = true;
            return {
                ...state,
                chartData,
                chartDataLoading,
                chartDataError,
            };
        }

        default:
            return state;
    }
};

export default twitterInsightsReducer;
